export default "__VITE_ASSET__DjpG4aJO__";